document.addEventListener("click", function (e) {
  if (e.target.closest(".js-header-drawer-close-button")) {
    let headerToggleMenuDrawer = '.js-header-drawer-close-button';
    window.themeCore.EventBus.emit("Toggle:headerToggleMenuDrawer:close");
  }
});
	document.addEventListener("DOMContentLoaded", function () {

  const togglers = document.querySelectorAll('.js-header-mega-menu-toggler');
  const main = document.querySelector('main');

  if (!main) return;

  togglers.forEach((toggler) => {

    const targetId = toggler.getAttribute('data-target');
    const megaMenu = document.getElementById(targetId);
    const megaContent = megaMenu?.querySelector('.js-header-mega-menu-content');

    const openMenu = () => {
      main.classList.add('mega-overlay-active');
      toggler.classList.add('hover-active');

      if (megaMenu) {
        megaMenu.classList.add('menu-active');
      }

      if (megaContent) {
        main.classList.add('mega-overlay-active');
        megaContent.classList.add('hover-active');
      }
    };

    const closeMenu = () => {
      toggler.classList.remove('hover-active');
      main.classList.remove('mega-overlay-active');

      if (megaMenu) {
        megaMenu.classList.remove('menu-active');
      }

      if (megaContent) {
        megaContent.classList.remove('hover-active');
        main.classList.remove('mega-overlay-active');
      }
    };

    toggler.addEventListener('mouseenter', openMenu);
    toggler.addEventListener('mouseleave', closeMenu);

    if (megaMenu) {
      megaMenu.addEventListener('mouseenter', openMenu);
      megaMenu.addEventListener('mouseleave', closeMenu);
    }

  });

});

// to udpate cart count
var sourceEl = document.querySelector("header .js-header-cart-item-count");

if (sourceEl) {

  function syncCart() {
    var newValue = sourceEl.innerText;

    var targetText = document.querySelector(".header-brand-tabs-wrapper .js-header-cart-item-count");
    var targetAttr = document.querySelector(".header-brand-tabs-wrapper .js-header-cart-item-count-wrapper");

    if (targetText) {
      targetText.innerText = newValue;
    }

    if (targetAttr) {
      targetAttr.setAttribute("data-cart-count", newValue);
    }
  }

  syncCart();

  var observer = new MutationObserver(function () {
    syncCart();
  });

  observer.observe(sourceEl, {
    childList: true,
    subtree: true,
    characterData: true
  });
}
// to udpate cart count
(function () {
  const originalFetch = window.fetch;
  let cachedCartToken = null;

  async function getCartToken() {
    if (cachedCartToken) return cachedCartToken;

    const res = await originalFetch('/cart.js');
    const cart = await res.json();
    cachedCartToken = cart.token;
    return cachedCartToken;
  }

  window.fetch = async function (...args) {
    let [url, config] = args;

    const isAddToCart =
      typeof url === "string" && url.includes("/cart/add");

    if (isAddToCart && config?.body) {
      try {
        const token = await getCartToken();
          // Handle JSON body (Ultra structure)
        if (typeof config.body === "string") {
          const bodyObj = JSON.parse(config.body);

          // Ultra uses "items"
          if (Array.isArray(bodyObj.items)) {
            bodyObj.items = bodyObj.items.map(item => ({
              ...item,
              properties: {
                ...(item.properties || {}),
                _cart_ID: token
              }
            }));
          } else {
            // fallback (rare)
            bodyObj.properties = {
              ...(bodyObj.properties || {}),
              _cart_ID: token
            };
          }

          config.body = JSON.stringify(bodyObj);
        }

        //Handle FormData (backup case)
        else if (config.body instanceof FormData) {
          config.body.append('properties[_cart_ID]', token);
        }

      } catch (e) {
        console.error("Cart ID inject error:", e);
      }
    }

    return originalFetch.apply(this, args);
  };
})();